import ShopStaffsPage from './ShopStaffsPage';

export default ShopStaffsPage;
